import {
  collection,
  doc,
  getFirestore,
  orderBy,
  query,
} from 'firebase/firestore';

export function getDocRef(
  collectionId: string,
  userId: string | undefined,
  type: string,
  itemId: string | undefined
) {
  if (!collectionId || !userId) return undefined;
  if (!itemId) return undefined;
  return doc(
    getFirestore(),
    'collections',
    collectionId,
    'users',
    userId,
    type,
    itemId
  );
}

export function getCollectionRef(
  collectionId: string | undefined,
  userId: string | undefined,
  type: string
) {
  if (!userId || !collectionId) return undefined;
  const ref = collection(
    getFirestore(),
    'collections',
    collectionId,
    'users',
    userId,
    type
  );
  return query(ref, orderBy('addedAt', 'desc'));
}
